import qs from "qs";
import {apiVoissa} from "../../libs/api";


export const fetchHomeFeedPopular = (query = {}, config = {}) => apiVoissa.get(`/home-feed/popular?${qs.stringify(query)}`, config);
export const fetchHomeFeedRecent = (query = {}, config = {}) => apiVoissa.get(`/home-feed/recent?${qs.stringify(query)}`, config);
export const fetchHomeFeedForYou = (query = {}, config = {}) => apiVoissa.get(`/home-feed/for-you?${qs.stringify(query)}`, config);
export const fetchHomeProfilesSuggest = (query = {}, config = {}) => apiVoissa.get(`/home-suggest?${qs.stringify(query)}`, config);

export const HOME_FEED_KEY = `home-feed`;
export const HOME_FEED_MEDIAS_KEY = `home-feed-medias`;
export const HOME_FEED_FOR_YOU_KEY = `home-feed-for-you`;
export const HOME_PROFILES_SUGGEST_KEY = `home-profiles-suggest`;
